export type PostTradeTabId = 'life-cycle';
export type RubricType = 'ranking' | 'trending';
export type Period = '1W' | '1M';

export type LifeCycleCategory =
  | 'near-to-maturity'
  | 'near-to-capital-barrier'
  | 'near-to-autocall'
  | 'with-capital-barrier-event'
  | 'with-no-more-option-value';

export interface LifeCycleProductsPagination {
  pageNumber: number;
  pageSize: number;
  total: number;
}

export interface LifeCycleSection {
  category: LifeCycleCategory;
  pagination: LifeCycleProductsPagination;
}

export const possibleRegions = ['France', 'Switzerland', 'WesternEurope'] as const;
export type Region = (typeof possibleRegions)[number];

export type DiscoverPageState = Readonly<{
  region?: Region;
  selectedPostTradeTab?: PostTradeTabId;
  selectedRubricTab: RubricType;
  selectedPeriod: Period;
  selectedSection: LifeCycleCategory;
  lifeCycleSections: LifeCycleSection[];
}>;

const defaultPagination = (): LifeCycleProductsPagination => ({ pageNumber: 0, pageSize: 5, total: 0 });

const getSection = (title: LifeCycleCategory): LifeCycleSection => ({
  category: title,
  pagination: defaultPagination(),
});
const titles: LifeCycleCategory[] = [
  'near-to-maturity',
  'near-to-capital-barrier',
  'near-to-autocall',
  'with-capital-barrier-event',
  'with-no-more-option-value',
];
export const initialDiscoverPageState: DiscoverPageState = {
  region: undefined,
  selectedPostTradeTab: undefined,
  selectedRubricTab: 'ranking',
  selectedPeriod: '1W',
  selectedSection: 'near-to-maturity',
  lifeCycleSections: titles.map(getSection),
};
